"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getVariantStyles = exports.getStateStylesWithOutlineOnFocus = exports.getStateStyles = void 0;
var _utils = require("../utils");
var _constants = require("./constants");
var _interfaces = require("./interfaces");
var _primaryVariantStyles = require("./primaryVariantStyles");
var _secondaryVariantStyles = require("./secondaryVariantStyles");
var _tertiaryInlineVariantStyles = require("./tertiaryInlineVariantStyles");
var _tertiaryVariantStyles = require("./tertiaryVariantStyles");
const getStateStylesWithOutlineOnFocus = (stateValues, borderColor, backgroundColor) => {
  const stateStyles = getStateStyles(stateValues);
  stateStyles[':focus-visible'] = {
    ...stateStyles[':focus-visible'],
    ...(0, _utils.addOutline)(_constants.OUTLINE_WIDTH, _constants.OUTLINE_OFFSET, borderColor, {
      color: backgroundColor,
      width: 1
    }).focus
  };
  return stateStyles;
};
exports.getStateStylesWithOutlineOnFocus = getStateStylesWithOutlineOnFocus;
const getStateStyles = stateValues => Object.keys(stateValues).reduce((_styles, stateKey) => ({
  ..._styles,
  [":".concat(stateKey)]: stateValues[stateKey]
}), {});
exports.getStateStyles = getStateStyles;
const getVariantStyles = _ref => {
  let {
    disabled = false,
    iconOnly,
    isDestructive = false,
    size,
    variant
  } = _ref;
  switch (variant) {
    case _interfaces.ButtonVariant.Primary:
      return {
        ...(0, _primaryVariantStyles.getPrimaryVariantStyles)({
          isDestructive,
          isDisabled: disabled,
          iconOnly,
          size
        })
      };
    case _interfaces.ButtonVariant.Tertiary:
      return {
        ...(0, _tertiaryVariantStyles.getTertiaryVariantStyles)({
          isDestructive,
          isDisabled: disabled,
          iconOnly,
          size
        })
      };
    case _interfaces.ButtonVariant.TertiaryInline:
    case _interfaces.ButtonVariant.TertiaryInlineWithUnderline:
      return {
        ...(0, _tertiaryInlineVariantStyles.getTertiaryInlineVariantStyles)({
          isDestructive,
          isDisabled: disabled,
          iconOnly,
          hasUnderline: variant === _interfaces.ButtonVariant.TertiaryInlineWithUnderline
        })
      };
    case _interfaces.ButtonVariant.Secondary:
    default:
      return {
        ...(0, _secondaryVariantStyles.getSecondaryVariantStyles)({
          isDestructive,
          isDisabled: disabled,
          iconOnly,
          size
        })
      };
  }
};
exports.getVariantStyles = getVariantStyles;